(() => {
  if (window.royalCartReturnSyncInstalled) return;
  window.royalCartReturnSyncInstalled = true;
  let running = null;
  const refresh = () => {
    if (running) return running;
    running = (async () => {
      const tasks = [];
      if (typeof window.upcartRefreshCart === 'function') {
        tasks.push(Promise.resolve().then(() => window.upcartRefreshCart()));
      }
      tasks.push((async () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', 'cart-icon-bubble');
        const response = await fetch(url.href, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('cart-sync');
        const sections = await response.json();
        if (typeof sections['cart-icon-bubble'] !== 'string') return;
        const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const content = html.querySelector('.shopify-section');
        const icon = document.getElementById('cart-icon-bubble');
        if (content && icon) icon.innerHTML = content.innerHTML;
      })());
      await Promise.allSettled(tasks);
    })().finally(() => { running = null; });
    return running;
  };
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refresh();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refresh();
  });
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('#cart-icon-bubble')) refresh();
  }, true);
})();
